import useElapsedSeconds, { formatElapsed } from '../../hooks/useElapsedSeconds';
import { SLOW_THINKING_TOOLS, SLOW_TOOL_HINT_THRESHOLD_SECONDS } from '../../lib/slowThinkingTools';
import styles from './BagelChatWidget.module.scss';

interface IThinkingPillProps {
  label: string;
  /** Raw tool name (e.g. "deploy_website") — used only to decide when to show the
   *  "this can take a while" reassurance for tools known to run long. */
  tool?: string;
}

export default function ThinkingPill({ label, tool }: IThinkingPillProps) {
  // This pill only ever renders while its tool is in progress, so "active" is implicit.
  const elapsed = useElapsedSeconds(label, true);
  const showElapsed = elapsed >= 3;
  const showSlowHint =
    tool && SLOW_THINKING_TOOLS.has(tool) && elapsed >= SLOW_TOOL_HINT_THRESHOLD_SECONDS;

  return (
    <div className={styles.thinkingIndicator} aria-live="polite">
      <span className={styles.thinkingSpinner} aria-hidden />
      <span>
        {label}
        {showElapsed && <span className={styles.thinkingElapsed}> ({formatElapsed(elapsed)})</span>}
        {showSlowHint && (
          <span className={styles.thinkingHint}> — this can take up to ~2 minutes, still working</span>
        )}
      </span>
    </div>
  );
}
